module.exports = __webpack_public_path__ + "static/media/ajax-Loader.2cdf31ef.gif";